import { createSlice } from '@reduxjs/toolkit'
import { fetchChecksReports } from './thunks/checks';

const initialState = {
    data: "",
    isLoading: false,
    error: null,
    filteredCaption: ""
}

const checksReport = createSlice({
    name: 'CHECKSREPORTSLICE',
    initialState,
    reducers: {
        addSymbols(state, action){
            state.availableSymbols = action.payload
        },
        setChecksFilteredCaption(state, action) {
          state.filteredCaption = action.payload
      }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchChecksReports.pending, (state) => {
          state.isLoading = true
        })
        builder.addCase(fetchChecksReports.fulfilled, (state, action) => {
          state.isLoading = false
          state.data = action.payload
        })
        builder.addCase(fetchChecksReports.rejected, (state, action) => {
          state.isLoading = false
          state.error = action.error.message
          state.data = null
        })
    }
});

export const { addSymbols, data, setChecksFilteredCaption } = checksReport.actions

export default checksReport;